module.exports = __webpack_public_path__ + "img/sql.b550dce2.svg";